import { useQuery } from "react-query";
import { showPreBudgetUnitDetails } from "Requests/Partners/PreBudgets";

export const usePreOrderDetails = (id: number) => {
  return useQuery({
    queryFn: () => showPreBudgetUnitDetails(Number(id)),
    queryKey: ["pre-order-detail-convertion", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
    enabled: !!id,
  });
};
